import { useFormContext } from "react-hook-form";
import TextArea from "@/components/TextArea/TextArea";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type SafetyAlarmInputFields = {
  safetyAlarmText: string;
};

const SafetyAlarmInput = ({
  safetyAlarmFieldConfig,
}: {
  safetyAlarmFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<SafetyAlarmInputFields>();

  return (
    <TextArea
      label={t`Sociala insatser`}
      showOptionalLabel={
        safetyAlarmFieldConfig ===
        informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.safetyAlarmText?.message}
      {...register("safetyAlarmText", {
        required: {
          value:
            safetyAlarmFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange information om sociala insatser`,
        },
      })}
    />
  );
};

export default SafetyAlarmInput;
